import { HammerGestureConfig } from "@angular/platform-browser";
import Hammer from "hammerjs";
import { Injectable } from "@angular/core";

@Injectable()
export class AppGestureConfig extends HammerGestureConfig {
  override buildHammer(element: HTMLElement) {
    const mc = new Hammer(element, {
      touchAction: "auto",
      inputClass: Hammer.TouchInput
    });
    mc.get("swipe").set({ direction: Hammer.DIRECTION_ALL });
    return mc;
  }
}
